import PreviewSupport from './PreviewSupport';

export default {
  __init__: [ 'previewSupport' ],
  previewSupport: [ 'type', PreviewSupport ]
};
